import { render, staticRenderFns } from "./AscRoleDialogGridWrapper.vue?vue&type=template&id=55778714&"
import script from "./AscRoleDialogGridWrapper.vue?vue&type=script&lang=js&"
export * from "./AscRoleDialogGridWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscRoleDialogGridWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports